
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ensemble",
      function () {
        return require("private-next-pages/ensemble/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ensemble"])
      });
    }
  